<template>
  <main-layout>
    <div>
      <h2>Texte</h2>
      <b-textarea v-model="text" @input="buildDialogue"></b-textarea>
      <hr>
    </div>
    <div v-if="locuteurs.length">
      <h2>Locuteurs</h2>
      <b-form-group v-for="l in locuteurs" :key="l.locuteur" :label="l.locuteur" label-cols="3">
        <b-form-select :options="options" v-model="l.voix" @input="resetHash(l.locuteur, $event)"></b-form-select>
      </b-form-group>
      <hr>
    </div>
    <div>
      <h2>Dialogue</h2>
      <b-table :items="dialogue" :fields="fields">
        <template #cell(audio)="{item}">
          <b-overlay :show="item.loading">
            <audio controls v-if="item.hash">
              <source :src="toSrc(item.hash)" type="audio/mpeg">
              Your browser does not support the audio element.
            </audio>
            <b-btn block v-else @click="generate(item)">
              Generer
            </b-btn>
          </b-overlay>
        </template>
      </b-table>
    </div>
  </main-layout>
</template>

<script>
import {Audio} from "@/js/caller";

export default {
  name: "DialogueCreatorView",
  data() {
    return {
      text     : "",
      titre    : "",
      locuteurs: [],
      dialogue : [],

      fields : ["locuteur", "dialogue", "audio"],
      options: ["Mathieu", "Celine", "Lea"]
    }
  },
  methods: {
    buildDialogue() {
      let {text}     = this;
      let titleIndex = -1;
      text           = text.trim();
      if (text.indexOf('\n') < text.indexOf(':')) {
        titleIndex = text.indexOf('\n')
        this.titre = text.slice(0, titleIndex);
      }
      this.dialogue  = this.getDialogue(text.slice(titleIndex + 1).split(':'));
      this.locuteurs = Array
          .from(new Set(this.dialogue.map(d => d.locuteur)))
          .map(locuteur => {
            return {
              locuteur,
              voix: ""
            }
          });
    },
    getDialogue([first, second, ...rest]) {
      if (!second) return [];
      const index = second.lastIndexOf('\n');
      const data  = {
        locuteur: first.trim(),
        dialogue: "",
        loading : true,
      }
      if (index === -1 || rest.length === 0) {
        data.dialogue = second.trim()
        return [data]
      }
      data.dialogue = second.slice(0, index).trim()
      return [
        data,
        ...this.getDialogue([second.slice(index), ...rest])
      ]
    },
    getVoiceId({locuteur}) {
      return this.locuteurs.find(l => l.locuteur === locuteur)?.voix || ""
    },
    resetHash(locuteur, voix) {
      this.dialogue
          .forEach(item => {
            if (item.locuteur !== locuteur) return;
            item.loading = true;
            Audio
                .GetHash(item.dialogue, {voiceId: voix})
                .then(res => {
                  item.hash    = res?.hash;
                  item.loading = false;
                });
          });
    },
    generate(item) {
      item.loading = true;
      Audio
          .Generate(item.dialogue, {voiceId: this.getVoiceId(item)})
          .then(res => {
            setTimeout(() => {
              item.hash    = res;
              item.loading = false;
            }, 2000)
          })
          .catch(() => {item.loading = false;})
    },
    toSrc(hash) {
      return process.env.VUE_APP_API_URL + `/audio/${hash}`;
    }
  }
}
</script>

<style scoped>

</style>